import { render, staticRenderFns } from "./LdmtStatus.vue?vue&type=template&id=54899a4c&scoped=true"
import script from "./LdmtStatus.vue?vue&type=script&lang=js"
export * from "./LdmtStatus.vue?vue&type=script&lang=js"
import style0 from "./LdmtStatus.vue?vue&type=style&index=0&id=54899a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54899a4c",
  null
  
)

export default component.exports